"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontFamilies = void 0;
exports.fontFamilies = {
    euclidCircularB: 'Euclid Circular B',
};
//# sourceMappingURL=fontFamilies.js.map